import { render, staticRenderFns } from "./TestFormio.vue?vue&type=template&id=4247639a"
import script from "./TestFormio.vue?vue&type=script&lang=js"
export * from "./TestFormio.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports